export const CoiffeurGender: { F: string; M: string; FM: string } = {
  F: 'female',
  M: 'male',
  FM: 'female-male',
}

export interface ICoiffeurServiceList {
  id: number
  name: string
}

export interface ICoiffeurService {
  locationName: string
  coiffeurCount: number
  id: number
  locationId: number
  lunchStartHour: string
  lunchEndHour: string
  reservationStartDay: number
  reservationEndDay: number
  isActive: boolean
}

export interface ICoiffeurSubServiceList {
  coiffeurMainServiceId: number
  id: number
  name: string
  gender: string
}

/* ############## Coiffeur Salon ############## */
export interface ICoiffeurSearchForm {
  mainServiceId: number
  subServiceId: number
  coiffeur: IFilteredCoiffeurList | null
  reservationDate: Date
}
export interface ICalendarCoiffeurSearchForm {
  locationId: number
  coiffeurSalonId: number
  mainServiceId: number
  subServiceId: number
  coiffeur: IFilteredCoiffeurList | null
  reservationDate: Date
}

export interface ICoiffeurSalonFilteredReq {
  locationId?: number
  locationIds?: number[]
  coiffeurServiceId?: number
  isEmployeeLocation?: boolean
  isIncludeNotActives?: boolean
  coiffeurMainServiceId?: number
  coiffeurSubServiceId?: number
  coiffeurId?: number
  reservationDate: Date
  isOnlyUserGender?: boolean
}

export interface ICoiffeurSalonSpecsFilteredReq {
  coiffeurSaloonId?: number
  coiffeurServiceId?: number
  locationId?: number
  coiffeurMainServiceId?: number
  coiffeurSubServiceId?: number
  isOnlyUserGender?: boolean
  isIncludeNotActives?: boolean
}

export interface ICoiffeurSaloonSpecsFilteredList {
  coiffeurSkillCount: number
  coiffeurSubService: {
    coiffeurMainService: {
      listCoiffeurSubService: [{}]
      id: number
      name: string
    }
    id: number
    name: string
    gender: string
  }
  id: number
  coiffeurSaloonId: number
  price: number
  priceMax: number
  duration: number
  isActive: true
}

export interface IListCoiffeurSaloonSpec {
  coiffeurSubService: {
    coiffeurMainService: { id: number; name: string }
    id: number
    name: string
    gender: string
  }
  id: number
  coiffeurSaloonId: number
  price: number
  priceMax: number | null
  duration: number
  isActive: boolean
}

interface ICoiffeurSalonFloor {
  id: number
  blockId: number
  locationId: number
  districtId: number
  cityId: number
  countryId: number
  locationFirmId: number
  floorTemplateId: number
  floorTemplateName: string
  name: string
  blockName: string
  locationName: string
  districtName: string
  cityName: string
  countryName: string
  locationFirmName: string
  locationMapsUrl: string
  locationRedirectMapsUrl: string
  isReservable: boolean
  reservationCapacity: number
  allowedOccupancy: number
  hasDedicatedTable: boolean
  isShared: boolean
  drawing: string
  templateIsActive: boolean
  dedicateTableCount: number
  floorProperties: [{ id: number; name: string; dictionaryCode: string; value: boolean }]
  occupancy: {
    id: number
    name: string
    capacity: number
    occupied: number
    percentage: number
    unavailableCount: number
    unavailablePercentage: number
    type: string
    emptyPercentage: number
    listPercentange: [number]
  }
}

export interface IFilteredCoiffeurSalonList {
  gender: 'F' | 'M'
  listMainServiceStr: [string]
  mainServiceCount: number
  startHourStr: string
  endHourStr: string
  id: number
  coiffeurServiceId: number
  name: string
  startHour: string
  endHour: string
  isActive: boolean
  coiffeurCount: number
  floor: ICoiffeurSalonFloor
  listCoiffeurSaloonSpec: IListCoiffeurSaloonSpec[]
  isFavorite: boolean
}

/* ############## Coiffeur ############## */
export interface ICoiffeurFilteredReq {
  coiffeurSalloonId: number
  coiffeurSubServiceId: number
  coiffeurMainServiceId: number
  isIncludeNotActives: boolean
}

export interface IFilteredCoiffeurList {
  coiffeurSkills: {
    coiffeurMainServiceId: number
    coiffeurMainServiceName: string
    coiffeurSubServiceName: string
    coiffeurSubServiceGender: string
    id: number
    coiffeurId: number
    coiffeurSubServiceId: number
  }[]
  coiffeurWorkingDays: {
    id: number
    coiffeurId: number
    startHourStr: string
    endHourStr: string
    dayOfWeekCode: number
    startHour: string
    endHour: string
  }[]
  id: number
  coiffeurSaloonId: number
  employeeId: number | null
  name: string
  surname: string
  email: string
  isActive: boolean
}

/* ############## Coiffeur Reservation - Time Table ############## */

export interface IGetCoiffeurTimeTableList {
  coiffeurId: number
  reservationStartHour: string
  reservationStartHourStr: string
  reservationEndHour: string
  reservationEndHourStr: string
  isSelectable: boolean
}

export interface IGetCoiffeurTimeTableReq {
  coiffeurId: number
  subserviceId: number
  startDate: string
  endDate: string
}

export interface ISaveCoiffeurReservation {
  id?: number
  coiffeurId: number
  reservationStartHour: string
  reservationEndHour: string
  employeeId?: number | null
  subserviceId?: number | null
  coiffeurReservationStatusId?: number | null
  cancelDate?: string | null
}
